import { useCallback, useRef } from "react";
import { createFreshChatConversationGuard } from "../utils/freshChatConversationGuard";

/** Owns conversation identity guards and the provider key for each workspace. */
export function useChatProviderGeneration(workspaceId: string | null) {
  const freshChatConversationGuardRef = useRef(
    createFreshChatConversationGuard(),
  );
  const reset = useCallback(
    (
      conversationId: string | number | null,
      cancelStream: () => void,
      clearLoading: () => void,
    ) => {
      freshChatConversationGuardRef.current.beginNewChat(conversationId);
      cancelStream();
      clearLoading();
    },
    [],
  );

  return {
    // Keep the provider mounted on New Chat so composer-local drafts (such as
    // attached files) survive. cancelStream aborts its passive subscription.
    providerKey: workspaceId ?? "no-workspace",
    reset,
    freshChatConversationGuardRef,
  };
}
